$(function() {
    $(document).ready(function() {
        if ($('.accordion')[0]) {
            const btn = $('.accordion__itemTitle');
            const content = $('.accordion__itemContent');

            $(btn).click(function() {
                var contentToToggle = $(this).next();
                $(btn)
                    .not(this)
                    .removeClass('active');
                $(content)
                    .not(contentToToggle)
                    .slideUp();
                $(this)
                    .toggleClass('active')
                    .next()
                    .slideToggle();
            });
        }
    });
});
